import { v4 as uuidv4 } from "uuid";
import { trackNewUser } from "../api/TaskCRUD";

export function getUserID() {
  let userID = localStorage.getItem("userID");
  if (!userID) {
    userID = uuidv4();
    localStorage.setItem("userID", userID);
    trackNewUser();
  }
  return userID;
}
